import ManagerGiftListDetail from './ManagerDetail.container';

export default ManagerGiftListDetail;
